<template>
    <div class="service">
        <div class="service--wrapper">
            <b-row>
                <b-col cols="11">
                    <div class="service--name">
                        <div class="toggle service--toggle" v-b-toggle="'service-'+service.service_index" v-html="chevron_down_toggler"></div>
                        <div class="service--title">
                            <b-form-group id="title" label="Servizio" label-for="title">
                                <b-form-input
                                    size="sm"
                                    id="title"
                                    v-model="service.details.title"
                                    placeholder="Nome del servizio"
                                    required
                                    debounce="500"
                                    @input="update_service"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="service--type">
                            <b-badge variant="secondary">{{ service.type }}</b-badge>
                        </div>
                        <div class="service--icon" @click="delete_service(service.service_index)">
                            <font-awesome-icon icon="times" />
                        </div>
                    </div>
                </b-col>
                <b-col cols="1" class="swappers">

                    <b-button
                        v-html="chevron_up"
                        variant="light"
                        size="sm"
                        :disabled="
                            services.findIndex(object => {
                                return object.service_index === service.service_index
                            }) == 0
                        "
                        @click=" () => {
                            let x = services.findIndex(object => {
                                    return object.service_index === service.service_index
                                })
                            swap_services(x,x-1)
                        }"
                    ></b-button>

                    <b-button
                        v-html="chevron_down"
                        variant="light"
                        size="sm"
                        :disabled="
                            this.services.findIndex(object => {
                                return object.service_index === service.service_index
                            }) == (services.length - 1)
                        "
                        @click="() => {
                            let x = services.findIndex(object => {
                                    return object.service_index === service.service_index
                                })
                            swap_services(x,x+1)
                        }"
                    ></b-button>
                    
                </b-col>
            </b-row>
            <b-collapse class="service--collapse" :id="'service-'+service.service_index" accordion="quote-accordion">
                <div class="service--content">
                    <transfer v-if="service.type === 'transfer'" :service="service" />
                    <overnight v-if="service.type === 'overnight'" :service="service" />
                    <flight v-if="service.type === 'flight'" :service="service" />
                    <generic v-if="service.type === 'generic'" :service="service" />
                    <insurance v-if="service.type === 'insurance'" :service="service" @updated_insurance_model="(value) => { update_service_with_model(value) }"/>
                    <package v-if="service.type === 'package'" :service="service" />
                </div>
                <common
                    :service_index="service.service_index"
                    :public_data="service.public_data"
                    :private_data="service.private_data"
                />
            </b-collapse>
        </div>
    </div>
</template>

<script>
    import ServiceOvernight from '@/components/blocks/overnight/service-overnight'
    import ServiceFlight from '@/components/blocks/flight/service-flight'
    //import ServiceHotel from '@/components/blocks/service-hotel'
    import ServiceGeneric from '@/components/blocks/service-generic'
    import ServiceInsurance from '@/components/blocks/service-insurance'
    import ServiceCommon from '@/components/blocks/service-common'
    import ServiceTransfer from '@/components/blocks/transfer/service-transfer'
    import { chevron_up, chevron_down, chevron_down_toggler } from '@/components/svg/common'
    import ServicePackage from '@/components/blocks/package/service-package'

    export default {
        name: 'quote-service',
        components: {
            'generic': ServiceGeneric,
            'insurance': ServiceInsurance,
            'overnight': ServiceOvernight,
            'flight': ServiceFlight,
            'transfer': ServiceTransfer,
            //'hotel': ServiceHotel,
            'common': ServiceCommon,
            'package': ServicePackage,
        },
        props: {
            service: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                services: this.$store.state.quote.services,
            }
        },
        created()
        {
            this.chevron_up = chevron_up
            this.chevron_down = chevron_down
            this.chevron_down_toggler = chevron_down_toggler
        },
        mounted() {
        },
        methods:{
            swap_services(x,y)
            {
                let quote = this.$store.state.quote,
                    services = quote.services,
                    new_x = services[y],
                    new_y = services[x]

                services[x] = new_x
                services[y] = new_y
                quote.services = services

                this.$store.commit('set_quote', quote)
                this.$emit('swapped')
            },
            update_service_with_model(model)
            {
                this.$store.commit('set_service', {
                    service: model
                })
            },
            update_service()
            {
                this.$store.commit('set_service', {
                    service: this.service
                })
            },
            delete_service(service_index)
            {
                let quote = this.$store.state.quote,
                    services = quote.services,
                    index = quote.services.findIndex(item => item.service_index === service_index)

                services.splice(index,1)
                quote.services = services
                this.$store.commit('set_quote', quote)
            }
        },
        computed: {
        }
    }
</script>

<style lang="scss">
    .service
    {
        border:1px solid rgba($secondary,0.25);
        padding:$grid-gutter-width/2 $grid-gutter-width/2;
        margin-bottom:$grid-gutter-width;
        //background:rgba($secondary,0.025);

        @each $name, $value in $servizi {//_variables.scss
            &--#{$name}
            {
                @extend .service--wrapper !optional;
            }
            &--#{$name}--item
            {
                @extend .service--item !optional;
            }
        } 

        &--wrapper
        {
            width:100%;
        }
        &--tools
        {
            display: flex;
            align-items: center;
        }
        &--toggle
        {
        }
        &--title
        {
            label
            {
                min-width: auto;
            }
            .form-group
            {
                min-width:100%;
                padding-left:1rem;
            }
        }
        &--collapse
        {
            width:100%;
            margin-top: $grid-gutter-width/2;
        }
        /*
        &--item--add,
        &--item--remove
        {
            margin:1rem 0;
            cursor:pointer;
            display:flex;
            align-items:center;
        }  
        */      
        &--inputs
        {
            display:flex;
            flex-wrap: wrap;
            .form-group
            {
                flex:100%;
                @include media-breakpoint-up(lg)
                {
                    flex:50%;
                    &:nth-child(even)
                    {
                        padding-left:$grid-gutter-width;
                    }
                    &:nth-child(odd)
                    {
                        padding-right:$grid-gutter-width;
                    }
                }
            }
        }
        &--name
        {
            display:flex;
            align-items: center;
            .form-group
            {
                margin-bottom: 0;
                margin-right:1rem;
                input
                {
                    min-width:300px;
                }
                label
                {
                    margin-right:1rem;
                    margin-bottom: 0 !important;
                    display: flex !important;
                    justify-content: center;
                    align-items: center;
                }
                display:flex;
                align-content: center;
                justify-content: center;
            }
        }
        &--tools
        {
            display:flex;
            align-items: center;
        }
        &--icon
        {
            margin-left:1rem;
            cursor: pointer;
        }
        &--field
        {
            &--title
            {
                color:$secondary;
                font-size: 14px;
                text-transform: uppercase;
                text-align: left;
                margin-bottom:2rem;
            }
        }
    }

    button > [data-icon]
    {
        margin:0 !important;
    }

    [data-icon="times"],
    [data-icon="plus"]
    {
        font-size: 22px;
        display: inline-block;
        margin:4px 10px !important;
        cursor:pointer;
    }

    [data-icon="times"]
    {
        color:$danger;
    }

    [data-icon="plus"]
    {
        color:$success;
    }

    //altro:
    .input-group-append .btn
    {
        padding-top:0;
        padding-bottom:0;
        box-shadow: none;
        outline:none;
        border-top-right-radius: $border-radius-sm;
        border-bottom-right-radius: $border-radius-sm;
    }

    .swappers
    {
        text-align: right;
        .btn
        {
            margin:0 4px;
            border-radius: 50%;
            width:32px;
            height:32px;
            color:$white;
            padding:0;
            border:1px solid rgba($black,0.15);
            svg
            {
                width:16px;
                height: auto;
            }
            &[disabled]
            {
                opacity:0.25;
            }
        }
    }
</style>